'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProviderIntent = require('../components/ProviderIntent.js');

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _utils = require('../../utils/utils');

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _WixSDKProviderApi = require('../components/WixSDKProviderApi');

var _WixSDKProviderApi2 = _interopRequireDefault(_WixSDKProviderApi);

var _photographyClientLib = require('@wix/photography-client-lib');

var _consts = require('../consts.js');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Infrastructure imports
var CartIntentOOI = function (_Component) {
  (0, _inherits3.default)(CartIntentOOI, _Component);

  function CartIntentOOI(props) {
    (0, _classCallCheck3.default)(this, CartIntentOOI);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartIntentOOI.__proto__ || (0, _getPrototypeOf2.default)(CartIntentOOI)).call(this, props));

    var artStoreApi = props.artStoreApi;

    _this.refreshItems = (0, _lodash.throttle)(artStoreApi.refreshCartItems, 1000);
    return _this;
  }
  /* eslint-disable no-case-declarations */


  (0, _createClass3.default)(CartIntentOOI, [{
    key: 'handleCartMessageReceived',
    value: function handleCartMessageReceived(type, payload, resolve, reject) {
      var _props = this.props,
          artStoreApi = _props.artStoreApi,
          cartItems = _props.cartItems,
          setCartIntent = _props.setCartIntent,
          isMobile = _props.isMobile,
          closeCart = _props.closeCart,
          connectedProviders = _props.connectedProviders,
          onGoToCheckout = _props.onGoToCheckout;

      switch (type) {
        case _providerEvents2.default.sdkReady:
          this.updateCartItem(cartItems);
          setCartIntent(this.cartIntent);
          break;
        case _providerEvents2.default.goToCheckout:
          onGoToCheckout(payload.additionalParams);
          break;
        case _providerEvents2.default.openModal:
          var options = payload.options,
              name = payload.name;

          var provider = (0, _keys2.default)(connectedProviders)[0];
          var providerData = connectedProviders[provider];
          var widgets = providerData.widgets;

          if (widgets[name] && [_consts.providerIntents.editor].includes(name)) {
            closeCart();
            this.props.toggleShopEditorPage((0, _extends3.default)({}, options, options.urlParams, { name: name }));
            this.cartItemUpdated = true;
            resolve();
            break;
          }
          resolve();
          break;
        case _providerEvents2.default.removeFromCart:
          artStoreApi.removeFromCart({ uuid: payload.uuid });
          break;
        case _providerEvents2.default.updateCartItem:
          artStoreApi.updateCartItem({
            uuid: payload.uuid,
            metadata: payload.metadata,
            quantity: payload.quantity
          });
          this.cartItemUpdated = true;
          break;
        default:
          break;
      }
    }
  }, {
    key: 'updateCartItem',
    value: function updateCartItem(cartItems) {
      if (this.cartIntent) {
        this.cartIntent.postMessage(_providerEvents2.default.refreshCart, cartItems);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var itemStatusChanged = this.didItemsStatusChanged(this.props.cartItems, newProps.cartItems);
      var itemsCountChanged = newProps.count !== this.props.count;
      var cartItemUpdated = this.cartItemUpdated;
      //count is saved on local storage (for aviod cart count flickering), it can be different from actual cart items
      var shouldRefreshCartItems = newProps.count !== this.getCartItemsCount(newProps.cartItems);
      if (shouldRefreshCartItems) {
        this.refreshItems(newProps.connectedProviders);
      }
      if (itemStatusChanged || itemsCountChanged || cartItemUpdated) {
        this.updateCartItem(newProps.cartItems);
        this.cartItemUpdated = false;
      }
    }
  }, {
    key: 'getCartItemsCount',
    value: function getCartItemsCount(cartItems) {
      var reducer = function reducer(accumulator, item) {
        return accumulator + item.quantity;
      };
      return cartItems.reduce(reducer, 0);
    }
  }, {
    key: 'didItemsStatusChanged',
    value: function didItemsStatusChanged() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var newItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (!(items.length && newItems.length)) {
        return false;
      }
      var getItemById = function getItemById(id, items) {
        return items.find(function (item) {
          return item.metadata.itemId === id;
        });
      };
      return !!newItems.find(function (newItem) {
        var item = getItemById(newItem.metadata.itemId, items);
        return item && newItem.status !== item.status;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          isMobile = _props2.isMobile,
          viewMode = _props2.viewMode,
          wixSdk = _props2.wixSdk,
          connectedProviders = _props2.connectedProviders,
          count = _props2.count,
          visible = _props2.visible,
          closeCart = _props2.closeCart,
          additionalProviderParams = _props2.additionalProviderParams;

      var containerStyles = {};
      var textStyles = {};
      var headerStyles = {};
      if (visible) {
        if (this.cartIntent) {
          this.cartIntent.setTabIndex(_utils.utils.getTabIndex('cartFrame'));
        }
      }
      var customAdditionalParams = {};
      if (additionalProviderParams) {
        var srcId = additionalProviderParams.srcId,
            appDefId = additionalProviderParams.appDefId,
            isAlbumStore = additionalProviderParams.isAlbumStore;

        srcId && (customAdditionalParams.srcId = srcId);
        appDefId && (customAdditionalParams.appDefId = appDefId);
        isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
      }
      var getClassName = function getClassName(base) {
        var cn = [base];
        if (visible) {
          cn.push(base + '-show');
        }
        cn.push(isMobile ? 'mobile' : 'desktop');
        return cn.join(' ');
      };
      var containerAttrs = {};
      // This is a workaround for a bug in the wix SDK
      // https://jira.wixpress.com/browse/SG-164
      if (viewMode === 'preview' && isMobile) {
        containerAttrs.style = {
          position: 'relative',
          width: '320px',
          height: '100vh',
          margin: '0px auto',
          overflow: 'hidden'
        };
      }
      var cartCloseImage = isMobile ? _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '27',
          height: '20',
          viewBox: '0 0 27 20'
        },
        _react2.default.createElement('path', {
          fill: 'currentcolor',
          fillRule: 'nonzero',
          d: 'M2.034 9.096l8.39-8.389L9.715 0 0 9.716l9.716 9.716.707-.707-8.629-8.63h25.155v-1H2.034z'
        })
      ) : _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '15',
          height: '27',
          viewBox: '0 0 15 27'
        },
        _react2.default.createElement('path', {
          fill: 'none',
          fillRule: 'evenodd',
          stroke: 'currentcolor',
          strokeWidth: '1.5',
          d: 'M.728 1L13.2 13.473.473 26.201'
        })
      );

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, containerAttrs, {
          style: { visibility: visible ? 'visible' : 'hidden' }
        }),
        _react2.default.createElement('div', { className: getClassName('overlay'), style: headerStyles, onClick: function onClick() {
            return closeCart();
          } }),
        _react2.default.createElement(
          'div',
          { className: getClassName('container') },
          _react2.default.createElement(
            'div',
            {
              className: 'header-button',
              style: headerStyles
            },
            _react2.default.createElement(
              'button',
              {
                className: 'header-arrow',
                style: textStyles,
                onClick: function onClick() {
                  return closeCart();
                },
                tabIndex: visible ? _utils.utils.getTabIndex('cartClose') : -1,
                'aria-label': 'Close Cart',
                ref: function ref(button) {
                  return _this2.closeButton = button;
                }
              },
              cartCloseImage
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-button-title', style: textStyles },
              _photographyClientLib.translationUtils.getByKey('Gallery _CartView_Cart_Label') + ' (' + count + ')'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'provider-container', style: containerStyles },
            _react2.default.createElement(_ProviderIntent2.default, (0, _extends3.default)({
              api: new _WixSDKProviderApi2.default(wixSdk),
              ref: function ref(r) {
                return _this2.cartIntent = r;
              },
              intent: 'cart',
              customAdditionalParams: customAdditionalParams,
              connectedProviders: connectedProviders,
              onMessageReceived: function onMessageReceived(type, payload, resolve, reject) {
                return _this2.handleCartMessageReceived(type, payload, resolve, reject);
              },
              customIframeStyle: { position: 'relative' }
            }, this.props))
          )
        )
      );
    }
  }]);
  return CartIntentOOI;
}(_react.Component);

exports.default = CartIntentOOI;